import { viewports } from '../constants/viewports';
import { orderProcess } from '../constants/order-process';

const state = {
    stickyContainers: [],
    currentViewport: viewports.MOBILE.name,
    currentOrderProcessStep: orderProcess.STEPS.NO_ORDER_ONGOING,
    checkoutIsOpen: false,
    currentConfigure3DStep: 0,
    screenSize: {
        width: 0,
        height: 0,
    },
    httpStatusCode: 200,
    pricesLoading: false,
};

const mutations = {
    SET_STICKY_CONTAINERS(state, containers) {
        state.stickyContainers = containers;
    },
    SET_SCREEN_SIZE(state, screenSize) {
        state.screenSize = screenSize;
    },
    SET_CURRENT_VIEWPORT(state, viewportName) {
        state.currentViewport = viewportName;
    },
    SET_CURRENT_ORDER_PROCESS_STEP(state, orderProcessStep) {
        state.currentOrderProcessStep = orderProcessStep;
    },
    SET_CHECKOUT_VISIBILITY(state, isOpen) {
        state.checkoutIsOpen = isOpen;
    },
    SET_LOGIN_STATE(state, login) {
        state.isUserLoggedIn = login;
    },
    SET_CURRENT_CONFIGURE_3D_STEP(state, configure3DStep) {
        state.currentConfigure3DStep = configure3DStep;
    },
    SET_HTTP_STATUS_CODE(state, statusCode) {
        state.httpStatusCode = statusCode;
    },
    SET_PRICES_LOADING(state, value) {
        state.pricesLoading = value;
    },
};

const actions = {
    addStickyContainer: ({ commit, state }, newContainer) => {
        const storedContainers = [...state.stickyContainers];

        storedContainers.splice(newContainer.order, 0, newContainer);
        commit('SET_STICKY_CONTAINERS', storedContainers);
    },
    setStickyContainer: ({ commit, state }, container) => {
        const storedContainers = [...state.stickyContainers];

        storedContainers.splice(container.order, 1, container);
        commit('SET_STICKY_CONTAINERS', storedContainers);
    },
    removeStickyContainer: ({ commit }, container) => {
        const storedContainers = [...state.stickyContainers];

        storedContainers.splice(container.order, 1);
        commit('SET_STICKY_CONTAINERS', storedContainers);
    },
    setScreenSize: ({ commit }, { width, height }) => {
        for (let viewportName in viewports) {
            let viewport = viewports[viewportName];
            if (viewport.minWidth <= width && width <= viewport.maxWidth) {
                commit('SET_CURRENT_VIEWPORT', viewport.name);
            }
        }
        commit('SET_SCREEN_SIZE', { width: width, height: height });
    },
    setCurrentOrderProcessStep: ({ commit }, orderProcessStep) => {
        commit('SET_CURRENT_ORDER_PROCESS_STEP', orderProcessStep);
    },
    setCheckoutVisibility: ({ commit }, isVisible) => {
        commit('SET_CHECKOUT_VISIBILITY', isVisible);
    },
    setLoginState: ({ commit }, login) => {
        localStorage.setItem('loggedIn', login);
        commit('SET_LOGIN_STATE', login);
    },
    toggleCheckoutVisibility: ({ commit, state }) => {
        commit('SET_CHECKOUT_VISIBILITY', !state.checkoutIsOpen);
    },
    setCurrentConfigure3DStep: ({ commit, state }, configure3DStep) => {
        commit('SET_CURRENT_CONFIGURE_3D_STEP', configure3DStep);
    },
    setHTTPStatusCode: ({ commit, state }, statusCode) => {
        commit('SET_HTTP_STATUS_CODE', statusCode);
    },
    setPricesLoading: ({ commit, state }, value) => {
        commit('SET_PRICES_LOADING', value);
    },
    fetchItemsFromLocalStorage: ({ commit, dispatch }) => {
        let paymentDetails = JSON.parse(localStorage.getItem('paymentDetails'));
        let userPreferences = JSON.parse(
            localStorage.getItem('userPreferences')
        );
        if (paymentDetails) {
            commit('SET_PAYMENT_DETAILS', paymentDetails);
        }
        if (userPreferences) {
            dispatch('updateUserPreferences', userPreferences);
        }
    },
};

const getters = {
    heightOfAllStickyContainers: (state) => (index) => {
        const storedContainers = [...state.stickyContainers];

        let height = 0;
        if (index < storedContainers.length) {
            for (let i = index - 1; i >= 0; i--) {
                height += storedContainers[i].containerHeight;
            }
        }

        return height;
    },
    screenSize: (state) => {
        return { ...state.screenSize };
    },
    currentViewport: (state) => {
        return state.currentViewport;
    },
    currentOrderProcessStep: (state) => {
        return state.currentOrderProcessStep;
    },
    isCheckoutOpen: (state) => {
        return state.checkoutIsOpen;
    },
    arePricesLoading: (state) => {
        return state.pricesLoading;
    },
    currentConfigure3DStep: (state) => {
        return state.currentConfigure3DStep;
    },
    httpStatusCode: (state) => {
        return state.httpStatusCode;
    },
};

export default { state, mutations, actions, getters };
